import SimpleStorage from '@/scripts/lib/SimpleStorage';

/** @extends {SimpleStorage<boolean>} */
export default class LikesStorage extends SimpleStorage {

   /** @param {string} slug */
   constructor(slug, { likes }) {
      super(`${slug}-likes`);

      this._slug = slug;
      this._total = likes;
   }

   rev() {
      this.value = !this.value;
   }

   _setValue(value) {
      const changed = super._setValue(value);
      if (!changed) return false;

      this.total += (value) ? 1 : -1;
      return true;
   }

   async _save() {
      if (this.disabled) return;
      this.disabled = true;

      super._save();

      const type = (this._value) ? 'like' : 'unlike';
      const url = `${process.env.SSR}/posts/${this._slug}/${type}`;

      try {
         const resp = await fetch(url, { method: 'POST' });
         if (!resp.ok) throw resp;
         this.total =  (await resp.json()).data.likes;
      } catch(e) {
         this.rev();
      } finally {
         this.disabled = false;
      }
   }

   get total() {
      return this._total;
   }

   set total(value) {
      if (this._total === value) return;
      this._total = value;
      this.events.emit('total', value);
   }

}